import useGridLayout from '@/hooks/useGridLayout';
import { inject, watch } from 'vue';
import { settingValue } from '@/utils/site-utils';
import { largeThanTablet } from '@/utils/dom-utils';

const GridLayout = (el, binding) => {
  let [start, span] = settingValue(binding.value, '0-24')
    .split('-')
    .map((x) => Number(x) ?? 0);
  start += 1;
  let style = '';
  if (largeThanTablet()) {
    style = `auto/${start}/auto/span ${span}`;
  } else {
    style = `auto/${Math.max(Math.floor(start / 2), 1)}/auto/span ${Math.max(Math.floor(span / 2), 1)}`;
  }
  el.style.gridArea = style;
};
export default GridLayout;
